<template>
  <Disclosure id="nav" :key="searchMenuKey" as="nav" class="bg-header page-container--small">
    <div class="relative flex items-center gap-3 py-4 lg:p-0">
      <div class="flex lg:h-20 items-center justify-between lg:justify-center w-full lg:relative">
        <Button
          v-if="hasGoBackButton && isB2C"
          color="neutral"
          class="items-center flex-none lg:absolute lg:left-0"
          @click="goBack"
          ><ChevronLeftIcon class="size-4" />{{ $t("Go back") }}</Button
        >
        <div class="hidden lg:flex flex-shrink-0 items-center">
          <RouterLink to="/"
            ><img class="logo ml-2 pr-4 lg:pr-0 lg:ml-0 max-h-6 self-center" :src="logo" alt="logo"
          /></RouterLink>
        </div>
        <div class="flex lg:hidden">
          <RouterLink to="/"><img class="logo max-h-6" :src="logo_mobile" alt="logo" /></RouterLink>
        </div>
      </div>
      <div class="ml-auto lg:absolute lg:right-0 flex items-center gap-4">
        <div v-if="userStore.isUser && !isB2C" class="flex gap-1 items-center">
          <UserIcon class="size-5" />
          <span v-if="!userStore.isIncognito" class="hidden lg:block text-base"> {{ userStore.distributor_name }}</span>
        </div>
        <RouterLink v-if="!isB2C" to="/" class="flex gap-1 hover:underline">
          <div class="flex items-center text-return">
            <ChevronLeftIcon class="h-5 self-center" />
            <span>{{ $t("Back to portal") }}</span>
          </div>
        </RouterLink>
        <LanguageMenuTopBar v-if="isB2C" class="text-primary-foreground" />
      </div>
    </div>

    <DisclosurePanel class="lg:hidden">
      <div class="space-y-1 pb-4 pt-2 overscroll-none">
        <MainMenu />
      </div>
    </DisclosurePanel>
  </Disclosure>
</template>

<script setup lang="ts">
import MainMenu from "./menu/MainMenu.vue";

import { Disclosure, DisclosurePanel } from "@headlessui/vue";
import { ChevronLeftIcon } from "@heroicons/vue/24/outline";
import brandconfig, { isB2C } from "@/brandconfig";
import { ref } from "vue";
import { useUserStore } from "@/store/user";
import { UserIcon } from "@heroicons/vue/24/outline";
import { Button } from "@xs2event/js-lib/components";
import { useRouter } from "vue-router";
import LanguageMenuTopBar from "@/components/page/menu/LanguageMenuTopBar.vue";

const { hasGoBackButton = true } = defineProps<{
  hasGoBackButton?: boolean;
}>();

const logo = brandconfig.LOGO;
const logo_mobile = brandconfig.LOGO_MOBILE;
const searchMenuKey = ref(0);

const userStore = useUserStore();
const router = useRouter();

const goBack = () => {
  router.back();
};
</script>

<style scoped>
.logo {
  min-height: 40px;
}

@media screen and (max-width: 1027px) {
  .logo {
    min-height: 30px;
  }
}
</style>
